import { theme } from "../theme"

const calcOverall = (topicArray) => {

    let overallStatus,
    { redCell, yellowCell, greenCell } = theme.colors

    const needMoreInfo = topicArray.some(item => Object.values(item).includes(-1))
    const deficiency = topicArray.some(item => Object.values(item).includes(1))

    let attribs = topicArray.filter(item => Object.values(item).includes(1)).map(item => item.title)

    // console.log('test', attribs)

    if (!!needMoreInfo){
      overallStatus = {
        title: 'Further information requested: ',
        message: "to get the best out of this analysis, please address the attributes that contain a yellow exclamation point in the table.",
        color: yellowCell,
        id: 5
      }
    } else  if (!!deficiency) {
      
  overallStatus = {
    title: 'Deficiency detected: ' ,
    message: "a potential site-wide deficiency indicated by the attributes with red flags in the table below",
    color: redCell,
    id: 1,
    summaryText: 'a site-wide deficiency indicated by',
    attribs,
  };
} else {
  let attribs = topicArray.map(item => item.title)
  overallStatus = {
      message: `No Deficiencies Detected`,
    color: greenCell,
    id: 4,
    summaryText: 'no concern regarding any of',
    attribs,
  }
}
return overallStatus
}

export default calcOverall